<template>
  <div>
    <b-card class="p-0 filter-card rounded-lg">
      <b-row>
        <b-col cols="12">
          <h3 class="ml-1 mb-2">
            الفلاتر
          </h3>
        </b-col>

        <!-- <b-col cols="4" v-if="types">
          <v-select
            v-model="filter.type_id"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="types"
            class="w-100 mb-0"
            :reduce="(val) => val.id"
            placeholder="User Role"
            :label="$i18n.locale == 'en' ? 'name' : 'name_local'"
          >
            <template v-slot:option="option">
              {{ $i18n.locale == "ar" ? option.name_local : option.name }}
            </template>
            <template #selected-option="{ name, name_local }">
              <div style="display: flex; align-items: baseline">
                <strong v-if="$i18n.locale == 'ar'">{{ name_local }} </strong>
                <strong v-else>{{ name }} </strong>
              </div>
            </template>
            <template #no-options>
              {{ $t("noMatching") }}
            </template>
          </v-select>
        </b-col> -->

        <b-col
          v-if="status_data"
          cols="12"
          md="4"
          class="mb-2 mb-md-0"
        >
          <v-select
            v-model="filter.status"
            :reduce="val => val"
            :get-option-label="option => option"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="status_data"
            class="w-100 mb-0"
            placeholder="User Status"
            :label="$i18n.locale == 'en' ? 'name' : 'name_local'"
          >
            <template v-slot:option="option">
              {{ $i18n.locale == "ar" ? option.name_local : option.name }}
            </template>
            <template #selected-option="{ name, name_local }">
              <div style="display: flex; align-items: baseline">
                <strong v-if="$i18n.locale == 'ar'">{{ name_local }} </strong>
                <strong v-else>{{ name }} </strong>
              </div>
            </template>
            <template #no-options>
              {{ $t("noMatching") }}
            </template>
          </v-select>
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-2 mb-md-0"
        >
          <b-form-input
            v-model="filter.keyword"
            placeholder="بحث"
          />
        </b-col>
      </b-row>

    </b-card>
    <b-card class="w-100 d-flex rounded-lg">
      <b-row>
        <b-col
          cols="12"
          class="pb-2 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center"
        >
          <h3 class="ml-1 mb-2 mb-md-0">
            المستخدمين
          </h3>
          <b-button
            v-if="hasPermission('create users')"
            class="btn rounded-pill mt-2 mt-md-0"
            variant="primary"
            size="sm"
            @click="openUserModal()"
          >
            <feather-icon
              icon="PlusIcon"
              size="14"
              class="mr-50"
            />
            مستخدم جديد
          </b-button>
        </b-col>
      </b-row>

      <center v-if="load">
        <b-spinner
          variant="primary"
          label="Spinning"
        />
      </center>
      <div v-else>
        <!-- Desktop Table View -->
        <div class="d-none d-md-block">
          <b-table
            :items="items.data"
            :fields="fields"
            fixed
            responsive
            striped
          >
            <template #filter />
            <template #cell(show_details)="row">
              <b-form-checkbox
                v-model="row.detailsShowing"
                plain
                class="vs-checkbox-con"
                @change="row.toggleDetails"
              >
                <span class="vs-checkbox">
                  <span class="vs-checkbox--check">
                    <i class="vs-icon feather icon-check" />
                  </span>
                </span>
                <span class="vs-label">{{
                  row.detailsShowing ? "Hide" : "Show"
                }}</span>
              </b-form-checkbox>
            </template>

            <template #row-details="row">
              <b-card>
                <b-row class="mb-2">
                  <b-col
                    md="4"
                    class="mb-1"
                  >
                    <strong>Full Name : </strong>{{ row.item.full_name }}
                  </b-col>
                  <b-col
                    md="4"
                    class="mb-1"
                  />
                  <b-col
                    md="4"
                    class="mb-1"
                  >
                    <strong>Email : </strong>{{ row.item.email }}
                  </b-col>
                  <b-col
                    md="4"
                    class="mb-1"
                  >
                    <strong>City : </strong>{{ row.item.city }}
                  </b-col>
                  <b-col
                    md="4"
                    class="mb-1"
                  >

                    <strong>Age : </strong>{{ row.item.age }}
                  </b-col>
                </b-row>

                <b-button
                  size="sm"
                  variant="outline-secondary"
                  @click="row.toggleDetails"
                >
                  Hide Details
                </b-button>
              </b-card>
            </template>

            <template #cell(avatar)="data">
              <b-avatar :src="data.item.avatar" />
            </template>

            <template #cell(fname)="data">
              <div>
                {{ data.item.fname + " " + data.item.lname }}
              </div>
            </template>

            <template #cell(roles)="data">
              <div>
                <span
                  v-for="role in data.item.roles"
                  :key="role.id"
                >
                  <b-badge
                    :variant="getRoleColor(role.name)"
                    class="mr-1"
                  >
                    {{ role.name }}
                  </b-badge>
                </span>
              </div>
            </template>
            <!-- <template #cell(role_name[0])="data">
          <b-badge :variant="status[1][data.item.roles[0]? data.item.roles[0].id :0]"  v-b-tooltip.hover.top="joinRoles(data.item.role_name)">
            {{data.item.role_name[0]}}
          </b-badge>
        </template> -->
            <template #cell(actions)="data">
              <div class="d-flex align-items-center">
                <!-- v-if="hasPermission('Active/Inactive Users')" -->
                <div v-if="hasPermission('active/inactive users')">
                  <feather-icon
                    v-if="data.item.status == 'active'"
                    v-b-tooltip.hover.top="'Inactive user'"
                    icon="UserCheckIcon"
                    class="mr-1 text-primary"
                    size="20"
                    @click="switchStatus(data.item)"
                  />
                  <feather-icon
                    v-else
                    icon="UserXIcon"
                    class="mr-1 "
                    :class="data.item.status == 'inactive' ? 'text-secondary' : 'text-info' "
                    size="20"
                    v-b-tooltip.hover.top="'Active user'"
@click="switchStatus(data.item)"
                  />
                </div>

                <feather-icon
                  v-if="hasPermission('edit users')"
                  v-b-tooltip.hover.top="'Edit User'"
                  icon="EditIcon"
                  size="20"
                  class="mr-1 text-info"
                  @click="openUserModal(data.item)"
                />

                <!-- <b-form-checkbox v-if="hasPermission('Active/Inactive Users')"
              @change="switchStatus(data.item)"
              :checked="checkboxStatus[data.item.id]"
              name="check-button"
              switch
              inline
            >
            </b-form-checkbox> -->
                <!-- <feather-icon class="font-weight-bolder" icon="KeyIcon" size="18"/> -->
                <b-link
                  v-if="hasPermission('assign-roles users')"
                  class="alert-link cutom-alert-link"
                  @click="assignRole(data.item)"
                >
                  <feather-icon
                    v-b-tooltip.hover.top="'Assign Role'"
                    icon="KeyIcon"
                    size="20"
                  />
                </b-link>
                <!-- <button class="btn btn-primary rounded-pill" @click="assignRole(data.item)">Assign Role</button> -->
                <feather-icon
                  v-if="hasPermission('delete users')"
                  v-b-tooltip.hover.top="'Delete User'"
                  icon="TrashIcon"
                  size="20"
                  class="ml-1 text-danger"
                  @click="deleteUser(data.item)"
                />
                <div
                  v-if="data.item.deleted_at != null"
                  class="d-flex align-items-center"
                >
                  <feather-icon
                    v-b-tooltip.hover.top="'Restore User'"
                    icon="RefreshCwIcon"
                    size="20"
                    class=" text-success"
                    @click="restoreUser(data.item)"
                  />
                  <feather-icon
                    v-b-tooltip.hover.top="'Hard delete'"
                    icon="TrashIcon"
                    size="20"
                    class="ml-1 text-danger"
                    @click="hardDelete(data.item)"
                  />
                </div>
              </div>
            </template>
          </b-table>
        </div>

        <!-- Mobile Card View -->
        <div class="d-md-none">
          <div
            v-for="(item, index) in items.data"
            :key="item.id || index"
            class="user-card-mobile mb-3"
          >
            <b-card class="shadow-sm">
              <div class="user-card-header mb-2">
                <div class="d-flex justify-content-between align-items-start">
                  <div class="flex-grow-1">
                    <h6 class="mb-1 font-weight-bold">
                      {{ item.name }}
                    </h6>
                    <small class="text-muted d-block">{{ item.email }}</small>
                  </div>
                  <b-badge
                    :variant="item.status === 'active' ? 'success' : item.status === 'inactive' ? 'secondary' : 'warning'"
                    class="ml-2"
                  >
                    {{ item.status }}
                  </b-badge>
                </div>
              </div>

              <div class="user-card-body">
                <div class="user-info-item mb-2">
                  <small class="text-muted d-block mb-1">الهاتف</small>
                  <div>{{ item.phone || '--' }}</div>
                </div>

                <div class="user-info-item mb-2">
                  <small class="text-muted d-block mb-1">الرقم القومي</small>
                  <div>{{ item.national_id || '--' }}</div>
                </div>

                <div
                  v-if="item.roles && item.roles.length > 0"
                  class="user-info-item mb-2"
                >
                  <small class="text-muted d-block mb-1">الادوار</small>
                  <div>
                    <b-badge
                      v-for="role in item.roles"
                      :key="role.id"
                      :variant="getRoleColor(role.name)"
                      class="mr-1 mb-1"
                    >
                      {{ role.name }}
                    </b-badge>
                  </div>
                </div>
              </div>

              <div class="user-card-actions mt-3 pt-2 border-top">
                <div class="d-flex flex-wrap justify-content-start align-items-center">
                  <div
                    v-if="hasPermission('active/inactive users')"
                    class="mr-2 mb-1"
                  >
                    <feather-icon
                      v-if="item.status == 'active'"
                      v-b-tooltip.hover.top="'Inactive user'"
                      icon="UserCheckIcon"
                      class="text-primary"
                      size="18"
                      @click="switchStatus(item)"
                    />
                    <feather-icon
                      v-else
                      v-b-tooltip.hover.top="'Active user'"
                      icon="UserXIcon"
                      :class="item.status == 'inactive' ? 'text-secondary' : 'text-info'"
                      size="18"
                      @click="switchStatus(item)"
                    />
                  </div>

                  <feather-icon
                    v-if="hasPermission('edit users')"
                    v-b-tooltip.hover.top="'Edit User'"
                    icon="EditIcon"
                    size="18"
                    class="mr-2 mb-1 text-info"
                    @click="openUserModal(item)"
                  />

                  <b-link
                    v-if="hasPermission('assign-roles users')"
                    class="mr-2 mb-1"
                    @click="assignRole(item)"
                  >
                    <feather-icon
                      v-b-tooltip.hover.top="'Assign Role'"
                      icon="KeyIcon"
                      size="18"
                    />
                  </b-link>

                  <feather-icon
                    v-if="hasPermission('delete users') && item.deleted_at == null"
                    v-b-tooltip.hover.top="'Delete User'"
                    icon="TrashIcon"
                    size="18"
                    class="mr-2 mb-1 text-danger"
                    @click="deleteUser(item)"
                  />

                  <div
                    v-if="item.deleted_at != null"
                    class="d-flex align-items-center"
                  >
                    <feather-icon
                      v-b-tooltip.hover.top="'Restore User'"
                      icon="RefreshCwIcon"
                      size="18"
                      class="mr-2 mb-1 text-success"
                      @click="restoreUser(item)"
                    />
                    <feather-icon
                      v-b-tooltip.hover.top="'Hard delete'"
                      icon="TrashIcon"
                      size="18"
                      class="mr-2 mb-1 text-danger"
                      @click="hardDelete(item)"
                    />
                  </div>
                </div>
              </div>
            </b-card>
          </div>
        </div>

        <b-pagination
          v-model="items.meta.current_page"
          align="center"
          :total-rows="items.meta.total"
          :per-page="items.meta.per_page"
          @change="onPageChange"
        />
      </div>
    </b-card>

    <b-modal
      id="modal-1-add-user"
      v-model="addNewUserModal"
      title="أضافة مستخدم جديد"
      hide-footer
      no-close-on-backdrop
      hide-header-close
      centered
      size="lg"
      class="user-modal"
    >
      <b-card-text>
        <b-form
          class="chat-app-form"
          autocomplete="off"
          @submit.prevent="submitUser"
        >
          <!-- Autofill decoys: prevent browser from filling vue-select internal search input with saved email -->
          <input
            type="text"
            name="fake_username"
            autocomplete="username"
            tabindex="-1"
            aria-hidden="true"
            style="position: absolute; left: -9999px; top: -9999px; height: 0; width: 0; opacity: 0;"
          >
          <input
            type="password"
            name="fake_password"
            autocomplete="new-password"
            tabindex="-1"
            aria-hidden="true"
            style="position: absolute; left: -9999px; top: -9999px; height: 0; width: 0; opacity: 0;"
          >
          <validation-observer
            ref="userForm"
            class="w-100"
          >
            <b-row class="pt-3">
              <b-col
                md="6"
                class="mb-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  vid="name"
                  rules="required"
                >
                  <b-form-group
                    label="الاسم *"
                    label-for="name"
                  >
                    <b-input-group class="input-group-merge form-send-message mr-1">
                      <b-form-input
                        v-model="user.name"
                        placeholder="الاسم"
                      />
                    </b-input-group>
                  </b-form-group>
                  <small class="text-danger float-left">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
              <b-col
                md="6"
                class="mb-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="email"
                  vid="email"
                  rules="email"
                >
                  <b-form-group
                    label="الايميل"
                    label-for="email"
                  >
                    <b-input-group class="input-group-merge form-send-message mr-1">
                      <b-form-input
                        v-model="user.email"
                        placeholder="الايميل"
                      />
                    </b-input-group>
                  </b-form-group>
                  <small class="text-danger float-left">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
              <b-col
                md="6"
                class="mb-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="national_id"
                  vid="national_id"
                  rules="required|national_id"
                >
                  <b-form-group
                    label="الرقم القومي *"
                    label-for="national_id"
                  >
                    <b-input-group class="input-group-merge form-send-message mr-1">
                      <b-form-input
                        v-model="user.national_id"
                        placeholder="الرقم القومي"
                        maxlength="14"
                      />
                    </b-input-group>
                  </b-form-group>
                  <small class="text-danger float-left">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
              <b-col
                md="6"
                class="mb-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="phone"
                  vid="phone"
                  rules="required|phone"
                >
                  <b-form-group
                    label="الهاتف*"
                    label-for="phone"
                  >
                    <b-input-group class="input-group-merge form-send-message mr-1">
                      <b-form-input
                        v-model="user.phone"
                        placeholder="الهاتف"
                      />
                    </b-input-group>
                  </b-form-group>
                  <small class="text-danger float-left">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
              <b-col
                md="6"
                class="mb-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="address"
                  vid="address"
                >
                  <b-form-group
                    label="العنوان"
                    label-for="address"
                  >
                    <b-input-group class="input-group-merge form-send-message mr-1">
                      <b-form-input
                        v-model="user.address"
                        placeholder="العنوان"
                      />
                    </b-input-group>
                  </b-form-group>
                  <small class="text-danger float-left">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
              <b-col
                sm="6"
                class="mb-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="الادوار"
                  vid="الادوار"
                  rules="required"
                >
                  <b-form-group
                    label="الادوار *"
                    label-for="roles"
                  >
                    <v-select
                      v-model="user.roles"
                      multiple
                      :options="roles"
                      :reduce="val => val.name"
                      :get-option-label="option => option.name"

                      :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                    >
                      <!-- Override internal search input to reduce chances of browser autofill -->
                      <template #search="scope">
                        <input
                          class="vs__search"
                          v-bind="scope.attributes"
                          name="roles_search"
                          autocomplete="new-password"
                          autocorrect="off"
                          autocapitalize="off"
                          spellcheck="false"
                          data-lpignore="true"
                          data-form-type="other"
                          v-on="scope.events"
                        >
                      </template>
                      <template #option="{ name }">
                        <span class="ml-50"> {{ name }}</span>
                      </template>

                      <template #selected-option="{ name }">
                        <span class="ml-50"> {{ name }}</span>
                      </template>

                    </v-select>
                  </b-form-group>
                  <small class="text-danger float-left">{{ errors[0] }}</small>
                </validation-provider>

              </b-col>
              <b-col
                v-if="!user.id || hasPermission('change password')"
                md="6"
                class="mb-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="password"
                  vid="password"
                  :rules="!user.id || hasPermission('change password') ? '': 'required' "
                >
                  <b-form-group
                    label="الباسورد"
                    label-for="password"
                  >
                    <b-input-group class="input-group-merge form-send-message mr-1">
                      <b-form-input
                        v-model="user.password"
                        type="password"
                        placeholder="الباسورد"
                      />
                    </b-input-group>
                  </b-form-group>
                  <small class="text-danger float-left">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
              <b-col
                v-if="!user.id || hasPermission('change password')"
                md="6"
                class="mb-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="password_confirmation"
                  vid="password_confirmation"
                  :rules="!user.id || hasPermission('change password') ? '' : 'required|confirmed:password' "
                >
                  <b-form-group
                    label=" تأكيد الباسورد"
                    label-for="password_confirmation"
                  >
                    <b-input-group class="input-group-merge form-send-message mr-1">
                      <b-form-input
                        v-model="user.password_confirmation"
                        type="password"
                        placeholder="الباسورد"
                      />
                    </b-input-group>
                  </b-form-group>
                  <small class="text-danger float-left">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
              <user-location-access-section
                v-if="hasPermission('view users')"
                ref="locationAccessSection"
                :user-id="user.id || null"
                :governorate-ids.sync="locationAccess.governorate_ids"
                :center-ids.sync="locationAccess.center_ids"
                :disabled="!hasPermission('edit users')"
                :validation-errors="locationAccessErrors"
              />
            </b-row>
          </validation-observer>
        </b-form>
        <div class="d-flex flex-column flex-sm-row justify-content-end mt-3">
          <b-button
            variant="primary"
            class="rounded-pill mb-2 mb-sm-0"
            size="sm"
            type="submit"
            @click="submitUser"
          >
            حفظ
          </b-button>
          <b-button
            class="rounded-pill ml-sm-1"
            size="sm"
            @click="addNewUserModal = false"
          >
            الغاء
          </b-button>
        </div>
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import {
  BTable,
  BButton,
  BFormCheckbox,
  BCard,
  BRow,
  BCol,
  BBadge,
  BCardText,
  BAvatar,
  BLink,
  VBTooltip,
  BSpinner,
  BPagination,
  BFormInput,
  BInputGroup,
  BForm,
  BFormGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  required, email, phone, national_id,
} from '@validations'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import UserLocationAccessSection from './Components/UserLocationAccessSection.vue'

export default {
  components: {
    BTable,
    BButton,
    BFormCheckbox,
    BCard,
    BForm,
    BRow,
    BCol,
    BBadge,
    BFormGroup,
    BAvatar,
    BInputGroup,
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
    BCardText,
    vSelect,
    BLink,
    BSpinner,
    BPagination,
    BFormInput,
    FeatherIcon,
    UserLocationAccessSection,
  },
  computed: {
    ...mapGetters({
      items: 'users/users',
      load: 'users/load',
      roles: 'roles/items',
    }),
    school_id_param() {
      return this.$route.query.school_id ? this.$route.query.school_id : null
    },
    type_id_param() {
      return this.$route.query.type_id ? this.$route.query.type_id : null
    },
    status_param() {
      return this.$route.query.status ? this.$route.query.status : null
    },
    keyword_param() {
      return this.$route.query.keyword ? this.$route.query.keyword : null
    },
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  watch: {
    checked(newVal) {
      if (newVal) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Form Submitted',
            icon: 'EditIcon',
            variant: 'success',
          },
        })
      }
    },
    'filter.type_id': function (newVal) {
      this.updateQueryParams()
      this.$store.dispatch('users/users', { query: this.filter, page: 1 })
    },
    'filter.status': function (newVal) {
      this.updateQueryParams()
      this.$store.dispatch('users/users', { query: this.filter, page: 1 })
    },
    'filter.keyword': function (newVal) {
      newVal == '' ? this.filter.keyword = null : this.filter.keyword = newVal
      this.updateQueryParams()
      this.$store.dispatch('users/users', { query: this.filter, page: 1 })
    },
  },
  data() {
    return {
      user: {
        name: '',
        email: '',
        phone: '',
        national_id: '',

        address: '',
        status: 'active',
        roles: [],
      },
      checkboxStatus: {},
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      checked: true,
      addNewUserModal: false,
      filter: {
        school_id: null,
        type_id: null,
        status: null,
        keyword: null,
      },
      status_data: [
        'active',
        'inactive',
        'suspended',
        'deleted',
      ],
      fields: [
        // "show_details",
        // { key: "avatar", label: "Avatar" },
        { key: 'name', label: 'الاسم', sortable: true },
        { key: 'email', label: 'الايميل', sortable: true },
        { key: 'phone', label: 'الهاتف' },
        { key: 'national_id', label: 'الرقم القومي' },
        { key: 'status', label: 'الحالة' },
        { key: 'roles', label: 'الادوار', sortable: true },
        'Actions',
      ],
      locationAccess: {
        governorate_ids: [],
        center_ids: [],
      },
      locationAccessErrors: {},

    }
  },

  mounted() {
    this.init()
  },
  methods: {
    emptyUser() {
      this.user = {
        name: '',
        email: '',
        phone: '',
        national_id: '',
        password: '',
        address: '',
        status: 'active',
      }
      this.locationAccess = {
        governorate_ids: [],
        center_ids: [],
      }
      this.locationAccessErrors = {}
    },
    buildUserPayload() {
      const payload = { ...this.user }
      if (this.hasPermission('edit users')) {
        payload.governorate_ids = this.locationAccess.governorate_ids || []
        payload.center_ids = this.locationAccess.center_ids || []
      }
      return payload
    },
    handleSubmitError(error) {
      if (!error.response) return
      if (error.response.status === 403) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'ليس لديك صلاحية',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        return
      }
      if (error.response.status === 422 && error.response.data.errors) {
        this.locationAccessErrors = error.response.data.errors
      }
      this.$swal({
        icon: 'error',
        title: `<h4>${error.response.data.message}</h4>`,
        showConfirmButton: true,
        confirmButtonColor: '#06284D',
        allowOutsideClick: true,
      })
    },
    submitUser() {
      this.locationAccessErrors = {}
      this.$refs.userForm.validate().then(async success => {
        if (!success) return

        if (this.$refs.locationAccessSection) {
          const confirmed = await this.$refs.locationAccessSection.confirmClearAccessIfNeeded()
          if (!confirmed) return
        }

        const query = this.buildUserPayload()
        const payload = { query }
        const hasLocationFields = this.hasPermission('edit users')

        if (this.user.id) {
          payload.id = this.user.id
          this.$store.dispatch('users/update', payload).then(res => {
            this.addNewUserModal = false
            this.emptyUser()
            this.init()
            if (hasLocationFields) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'تم حفظ صلاحيات الموقع بنجاح',
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
            }
            this.$swal({
              icon: 'success',
              title: `<h4>${res.message}</h4>`,
              showConfirmButton: true,
              confirmButtonColor: '#06284D',
              allowOutsideClick: true,
            })
          }).catch(error => {
            this.handleSubmitError(error)
          })
        } else {
          this.$store.dispatch('users/store', payload).then(res => {
            this.addNewUserModal = false
            this.emptyUser()
            this.init()
            if (hasLocationFields) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'تم حفظ صلاحيات الموقع بنجاح',
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
            }
            this.$swal({
              icon: 'success',
              title: `<h4>${res.message}</h4>`,
              showConfirmButton: true,
              confirmButtonColor: '#06284D',
              allowOutsideClick: true,
            })
          }).catch(error => {
            this.handleSubmitError(error)
          })
        }
      })
    },
    getRoleColor(roleName) {
      const role = roleName.toLowerCase()

      if (role.includes('admin')) return 'danger'
      if (role.includes('editor')) return 'warning'
      if (role.includes('moderator')) return 'info'
      if (role.includes('author')) return 'success'
      if (role.includes('user')) return 'primary'
      if (role.includes('subscriber')) return 'secondary'

      return 'dark'
    },
    onPageChange(page) {
      this.$store.dispatch('users/users', { query: { ...this.filter, page } })
    },
    refreshData() {
      this.$store.dispatch('users/users', { query: { ...this.filter, page: this.items.current_page } })
    },
    joinRoles(roles) {
      return roles.join(', ')
    },
    updateQueryParams() {
      const queryParams = {
        type_id: this.filter.type_id || null,
        status: this.filter.status || null,
        keyword: this.filter.keyword || null,
      }
      this.$router.replace({ query: queryParams })
    },
    init() {
      this.$store.dispatch('users/users', { query: { ...this.filter, page: 1 } }).then(res => {
        this.$store.dispatch('roles/listRoles')
      })
    },
    assignRole(item) {
      this.$router.push({ name: 'assign_role', params: { id: item.id } })
    },
    switchStatus(item) {
      const _this = this
      const previousStatus = this.checkboxStatus[item.id]
      const arrList = this.checkboxStatus
      this.$swal({
        icon: 'warning',
        title: `هل انت متأكد من ${item.status == 'active' ? 'تعطيل' : 'تفعيل'} المستخدم؟`,
        showCancelButton: true,
        confirmButtonText: 'نعم, متأكد!',
        cancelButtonText: 'الغاء',
        confirmButtonColor: '#06284D',
      }).then(isConfirm => {
        if (isConfirm.isConfirmed) {
          _this.$store.dispatch('users/inactiveUser', item.id).then(_ => {
            _this.refreshData()
          })
        } else {
          _this.$set(arrList, item.id, previousStatus)
        }
      }).finally(_ => {
        this.checkboxStatus = arrList
      })
    },
    exportUsers() {
      const filteredData = this.filter
      this.$store
        .dispatch('users/exportUsers', filteredData)
        .then(res => {
          this.$swal({
            icon: 'success',
            title: '<h4>Users exported successfully</h4>',
            showConfirmButton: true,
            confirmButtonColor: '#06284D',
            allowOutsideClick: true,
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: `<h4>${error.response.data.error}</h4>`,
              showConfirmButton: true,
              confirmButtonColor: '#06284D',
              allowOutsideClick: true,
            })
          }
        })
    },
    openUserModal(user = null) {
      this.locationAccessErrors = {}
      this.user = user ? {
        id: user.id,
        name: user.name,
        email: user.email,
        phone: user.phone,
        national_id: user.national_id,
        address: user.address,
        roles: user.roles.map(role => role.name),

      } : {
        name: '',
        email: '',
        phone: '',
        national_id: '',
        password: '',
        password_confirmation: '',
        address: '',
        roles: [],
      }
      if (!user) {
        this.locationAccess = {
          governorate_ids: [],
          center_ids: [],
        }
      }
      this.addNewUserModal = true
    },
    hardDelete(item) {
      this.$swal({
        title: 'هل أنت متأكد؟',
        text: 'سيتم حذف المستخدم بشكل نهائي!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'نعم، احذف!',
        cancelButtonText: 'إلغاء',
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch('users/hardDeleteUser', item.id)
            .then(() => {
              this.$swal('تم الحذف!', 'تم حذف المستخدم.', 'success')
              this.refreshData()
            })
            .catch(err => {
              this.$swal('خطأ!', err?.response?.data?.message || 'حدث خطأ أثناء الحذف', 'error')
            })
        }
      })
    },
    restoreUser(item) {
      this.$swal({
        title: 'هل أنت متأكد؟',
        text: 'سيتم استعادة المستخدم!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'نعم، استعادة!',
        cancelButtonText: 'إلغاء',
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch('users/restoreUser', item.id)
            .then(() => {
              this.$swal('تم الاستعادة!', 'تم استعادة المستخدم.', 'success')
              this.refreshData()
            })
            .catch(err => {
              this.$swal('خطأ!', err?.response?.data?.message || 'حدث خطأ أثناء الاستعادة', 'error')
            })
        }
      })
    },
    deleteUser(item) {
      this.$swal({
        title: 'هل أنت متأكد؟',
        text: 'سيتم حذف المستخدم بشكل نهائي!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'نعم، احذف!',
        cancelButtonText: 'إلغاء',
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch('users/deleteUser', item.id)
            .then(() => {
              this.$swal('تم الحذف!', 'تم حذف المستخدم.', 'success')
              this.refreshData()
            })
            .catch(err => {
              this.$swal('خطأ!', err?.response?.data?.message || 'حدث خطأ أثناء الحذف', 'error')
            })
        }
      })
    },
    restoreUser(item) {
      this.$swal({
        title: 'هل أنت متأكد؟',
        text: 'سيتم استعادة المستخدم!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'نعم، استعادة!',
        cancelButtonText: 'إلغاء',
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch('users/restoreUser', item.id)
            .then(() => {
              this.$swal('تم الاستعادة!', 'تم استعادة المستخدم.', 'success')
              this.refreshData()
            })
            .catch(err => {
              this.$swal('خطأ!', err?.response?.data?.message || 'حدث خطأ أثناء الاستعادة', 'error')
            })
        }
      })
    },
    hardDelete(item) {
      this.$swal({
        title: 'هل أنت متأكد؟',
        text: 'سيتم حذف المستخدم بشكل نهائي!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'نعم، احذف!',
        cancelButtonText: 'إلغاء',
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch('users/hardDelete', item.id)
            .then(() => {
              this.$swal('تم الحذف!', 'تم حذف المستخدم.', 'success')
              this.refreshData()
            })
            .catch(err => {
              this.$swal('خطأ!', err?.response?.data?.message || 'حدث خطأ أثناء الحذف', 'error')
            })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";

/* Mobile Card View Styles */
.user-card-mobile {
  .user-card-header {
    h6 {
      font-size: 1rem;
      margin-bottom: 0.25rem;
    }
  }

  .user-info-item {
    small {
      font-size: 0.75rem;
      font-weight: 600;
    }
    div {
      font-size: 0.875rem;
      word-break: break-word;
    }
  }

  .user-card-actions {
    ::v-deep .feather-icon,
    ::v-deep a {
      cursor: pointer;
      transition: opacity 0.2s;

      &:hover {
        opacity: 0.7;
      }
    }
  }
}

/* Mobile Responsive Styles */
@media (max-width: 767.98px) {
  .filter-card {
    .b-row {
      margin: 0;
    }

    .b-col {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
  }

  ::v-deep .b-table {
    font-size: 0.8rem;

    th, td {
      padding: 0.5rem 0.25rem;
      font-size: 0.8rem;
    }
  }

  .user-card-mobile {
    .user-card-header h6 {
      font-size: 0.95rem;
    }
  }

  ::v-deep .user-modal {
    .modal-dialog {
      margin: 0.5rem;
      max-width: calc(100% - 1rem);
    }
  }
}

/* Extra Small Devices */
@media (max-width: 575.98px) {
  .user-card-mobile {
    .user-card-header h6 {
      font-size: 0.9rem;
    }

    .user-info-item {
      small {
        font-size: 0.7rem;
      }
      div {
        font-size: 0.8rem;
      }
    }
  }
}

/* Ensure proper scrolling on mobile */
@media (max-width: 767.98px) {
  ::v-deep .table-responsive {
    -webkit-overflow-scrolling: touch;
  }
}
</style>
